const Builder = require('../BuilderBase');

module.exports = class MenuItem extends Builder {
    constructor(title, properties) {
        super('menuSelection_MenuItem', title, properties);
    }
};
